import LayoutPage from '@/view/layout/LayoutApp'

export default [{
    path: '/sheet-app',
    component: LayoutPage,
    children: [{
        path: 'local/edit/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-local-edit-app',
        component: () => import('@/view/sheet/EditFichaLocalApp'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
            }
        }
    }]
}]
